/*
 * Fetches a catalog type from API and optionally
 * saves it in the vuex store
 * (note: you must first add the catalog type to the
 * vuex catalog module state)
 *
 * Usage: catalogService.fetch('highway')
 *          .then(=> ...)
 *
 * Automatic collection management
 *   catalogService.fetch('highway', {source: this.highways})
 *
 * To receive a particular item:
 *
 * catalogService.fetch('highway', 27)
 *
 * catalogService.fetch('highway', {useStore: true})
 */

import Vue from 'vue'
import store from './../../store'
import catalogTransformers from './../../transformers/catalog'

const save = (catalog, data) => {
  store.dispatch('catalogs/store', data)
}

export default (catalog, opts = {}) => {
  if (typeof (opts) !== "object") {
    opts = { id: opts }
  }

  const base = `/${opts.path || 'catalogs'}`
  let url = `${base}/${catalog ? `${catalog}/` : ''}`

  if (opts.id) {
    url += `${opts.id}/`
  }

  if (opts.extraId) {
    url += `${opts.extraId}/`
  }

  const fetchDetail = !opts.collection && !!opts.id

  return Vue.$http.get(url, opts.config)
    .then((response) => {
      const transformer = opts.transformer || catalogTransformers[catalog]
      let data = response ? response.data : {}
      let paginationInfo

      if (opts.paginated) {
        const { results, ...pagInfo } = data
        data = results
        paginationInfo = pagInfo
      }

      if (transformer && transformer.fetch) {
        data = fetchDetail ?
          transformer.fetch(data) : transformer.fetchCollection(data)
      }

      if (!fetchDetail && opts.useStore) {
        save(catalog, { type: catalog, data })
      }

      if (!paginationInfo) {
        return data
      }
        return { results: data, paginationInfo }
    })
}



// WEBPACK FOOTER //
// ./src/services/catalog/fetch.js